import { n } from '@/i18n';
import { useProjectsStore } from '@/store/projects';
import { isNumber } from '.';

let projectsStore = undefined;

export const translatedCurrencyCents = (input: number | undefined) => {
  projectsStore = projectsStore ?? useProjectsStore();

  const locale = projectsStore.currentLocale;
  const number = input ?? 0;

  return n(isNumber(number) ? number : 0, 'currencyCents', locale);
};

export const translatedCurrency = (input: number | undefined) => {
  projectsStore = projectsStore ?? useProjectsStore();

  const locale = projectsStore.currentLocale;
  const number = input ?? 0;

  return n(isNumber(number) ? number : 0, 'currency', locale);
};

export const translatedNumber = (input: number | undefined) => {
  projectsStore = projectsStore ?? useProjectsStore();

  const locale = projectsStore.currentLocale;
  const number = input ?? 0;

  return n(isNumber(number) ? number : 0, 'number', locale);
};

export const translatedDecimal = (input: number | undefined) => {
  projectsStore = projectsStore ?? useProjectsStore();

  const locale = projectsStore.currentLocale;
  const number = input ?? 0;

  return n(isNumber(number) ? number : 0, 'decimal', locale);
};

export const translatedPercent = (input: number | undefined) => {
  projectsStore = projectsStore ?? useProjectsStore();

  const locale = projectsStore.currentLocale;
  const number = input ?? 0;

  return n(isNumber(number) ? number / 100 : 0, 'percent', locale);
};

export const tcc = translatedCurrencyCents;

export const tc = translatedCurrency;

export const tn = translatedNumber;

export const td = translatedDecimal;

export const tp = translatedPercent;
